import React, { useEffect, useRef } from 'react';
import './Hero.css';

const Hero = () => {
  const statsRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.2 }
    );
    const items = statsRef.current?.querySelectorAll('.stat-item');
    items?.forEach((item) => observer.observe(item));
    return () => items?.forEach((item) => observer.unobserve(item));
  }, []);

  return (
    <section id="home" className="hero">
      <div className="hero-bg" />
      <div className="hero-content">
        <h1 className="hero-title">
          Welcome to <span className="highlight">MTC</span> School
        </h1>
        <p className="hero-subtitle">
          Nurturing Minds, Building Futures. We provide quality education that
          empowers students to achieve their full potential and become tomorrow's leaders.
        </p>
        <div className="hero-buttons">
          <a href="#programs" className="btn btn-gold">Explore Programs</a>
          <a href="#about" className="btn btn-outline-white">Learn More</a>
        </div>
        <div className="hero-stats" ref={statsRef}>
          <div className="stat-item">
            <span className="stat-number">4</span>
            <span className="stat-label">Expert Faculty</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">5000+</span>
            <span className="stat-label">Students Enrolled</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">150+</span>
            <span className="stat-label">Expert Teachers</span>
          </div>
          <div className="stat-item">
            <span className="stat-number">98%</span>
            <span className="stat-label">Success Rate</span>
          </div>
        </div>
      </div>
      <div className="hero-scroll">
        <a href="#about">
          <span className="scroll-text">Scroll Down</span>
          <span className="scroll-icon">{'\u2193'}</span>
        </a>
      </div>
    </section>
  );
};

export default Hero;
